export class SetUtils {

  public static toArray<T>(set: Set<T>): T[] {
    return Array.from(set.values());
  }

  public static takeFirst<T>(set: Set<T>): T {
    return this.toArray(set)[0];
  }
}